import styled from 'styled-components';
import { StyledInput } from '../Input/styles';
export const TextareaComponent = styled(StyledInput) `
	resize: none;
	max-height: 96px;
`;
//# sourceMappingURL=styles.js.map